__webpack_require__.p = "/wsOnePortaria/Plus/";